import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  PostRequestBase,
  ResponseBase,
  ScreenModel,
  ResponseData,
  RequestData
} from '../../../../core/models/common';
import {
  ManagedContent,
  ManagedContentServerData,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { AppUtilityService } from '../../../../core/services/app-utility.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SharedAPIService } from '../../../../core/services/shared-api.service';

// What we receive from the API when page is loaded
export interface AccreditedInvestorData extends ResponseBase {
  IsQualifiedAccreditedInvestor: boolean | null;
  TermsAndConditionsContent?: ManagedContentServerData;
  HasReadTermsAndConditions: boolean;
}

// What we will send to the API when submit
export interface AccreditedInvestorRequestData extends PostRequestBase {
  IsQualifiedAccreditedInvestor?: boolean | null;
}

// What we work with in this screen.
export class AccreditedInvestorModel extends ScreenModel {
  
  
  screenName = 'AccreditedInvestor';
  data: AccreditedInvestorData | undefined;
  isQualifiedAccreditedInvestor: boolean | null = null;
  termsAndConditions?: ManagedContent | null;
  hasReadTermsAndConditions: boolean = false;
  pageID_read = 'R0030';
  pageID_write = 'S0030';
  termsAndConditionsHTML :string ='';
 
  // Data lifecycle start.

  deriveFromData(data: ResponseBase) {
    
    this.isQualifiedAccreditedInvestor = (data as any)['QualifyAccreditedInvestor'] == 'Yes'?true:(data as any)['QualifyAccreditedInvestor'] == 'No'?false:null;
   // this.isQualifiedAccreditedInvestor = true;

    this.termsAndConditions = 
       {
          title : '',
          body: this.termsAndConditionsHTML,
        }
      

     this.hasReadTermsAndConditions = false;

    console.log('deriveFromData, model:', this);
  }

  mapPegaObjToUI(data : any){
    console.log("FIRSTEVER MAPPING TEST +++++++")
    console.log(data)
    
     return data;
   }

  // Constructs a JSON object to be sent to server.
  deriveDataFromModel(): RequestData {
    // @For integration.
    let isQualifiedAccreditedInvestorString = this.isQualifiedAccreditedInvestor?'Yes':'No';
    return {
      ServiceBody :{QualifyAccreditedInvestor :isQualifiedAccreditedInvestorString}// this.isQualifiedAccreditedInvestor}
    };
  }

  // Data lifecycle end.

  syncModelWithForm() {
    console.log('[AccreditedInvestorModel] syncModelWithForm');
    const formValues = this.form?.value;
    this.isQualifiedAccreditedInvestor =
      formValues.isQualifiedAccreditedInvestor;
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}

@Component({
  selector: 'app-accredited-investor',
  templateUrl: './accredited-investor.component.html',
  styleUrls: ['./accredited-investor.component.scss'],
})
export class AccreditedInvestorComponent implements OnInit {
  pageID_read = 'R0030';
  pageID_write = 'S0030';
  pageName = 'AccreditedInvestor';

  model = new AccreditedInvestorModel(this.globals, this.apiService, this.el);
  form: FormGroup = this.formBuilder.group({
    isQualifiedAccreditedInvestor: [undefined, [Validators.required]],
  });

  @ViewChild('modalTermsAndConditions', { static: false })
  modalTermsAndConditions: ElementRef | undefined;

  modalTermsAndConditionsInstance: NgbModalRef | undefined;

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private appUtility: AppUtilityService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private el: ElementRef,
    private sharedAPIService : SharedAPIService
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.getSavePageID = this.getSavePageID;
  }

  async ngOnInit() {
    this.model.pageID = this.pageID_read;
    this.model.screenName = this.pageName;
    this.model.termsAndConditionsHTML = this.sharedAPIService.getTermsAndConditions();
 
    await this.model.loadData();
    console.log('ACCREDITEDD READ SUCESS')
    console.log(this.model)
    
    if (
      !this.model.hasReadTermsAndConditions &&
      this.model.termsAndConditions
    ) {
      this.modalTermsAndConditionsInstance = this.modalService.open(
        this.modalTermsAndConditions,
        {
          backdrop: 'static',
          keyboard: false,
          scrollable: true,
        },
      );
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    this.isQualifiedAccreditedInvestorControl.setValue(
      this.model.isQualifiedAccreditedInvestor,
    );
  };

  goToPreviousScreen = async () => {
    console.log('[AccreditedInvestorComponent] goToPreviousScreen');
    await this.router.navigateByUrl('/login');
  };

  getSavePageID =()=> {
    
    return this.pageID_write;
  }

  goToNextScreen = async () => {
    console.log('[AccreditedInvestorComponent] goToNextScreen');
    if (this.model.isQualifiedAccreditedInvestor) {
      await this.router.navigateByUrl('/fna/accredited-investor-application');
    } else {
      await this.router.navigateByUrl('/fna/organisation-information');
    }
  };

  handleAcceptTermsAndConditions() {
    if (this.globals.simulateServerBehaviour) {
      this.globals.mockHasReadTermsAndConditions = true;
    }

    this.modalTermsAndConditionsInstance?.close();
  }

  async handleRejectTermsAndConditions() {
    await this.appUtility.logout({});
  }

  // Form controls

  get isQualifiedAccreditedInvestorControl() {
    return this.form.get('isQualifiedAccreditedInvestor') as FormControl;
  }

  // Form controls end
}
